<div class="filter-container">
  <div class="left-div">
    <div class="customer-name-search">
      <div class="customer-name-label">
        <div class="strong">Zoek op klantnaam</div>
      </div>
      <filter-input
        [filterObject]="getFilterForKey('immoNewCustomerName')"
        (click)="$event.preventDefault() && $event.stopPropagation()"
        (toggleFilterEmitter)="toggleFilter($event)"
        (filterValueChanged)="onFilterValueChange($event)"
      ></filter-input>
    </div>
  </div>
  <div class="right-div">
    <filter-checkbox
      [filterObject]="getFilterForKey('needsBillingReadyConfirmation')"
      (toggleFilterEmitter)="toggleFilter($event)"
      (filterValueChanged)="onFilterValueChange($event)"
      [label]="'Goed te keuren'"
    ></filter-checkbox>
  </div>
</div>

<hr />

<div [ngClass]="loading ? 'lock' : ''">
  <div *ngIf="loading" class="table-loader-overlay" style="margin-top: 55px">
    <div style="margin-top: 145px; align-self: center">
      <mat-spinner
        style="margin: auto"
        color="primary"
        diameter="75"
      ></mat-spinner>
    </div>
  </div>
  <div class="table-container">
    <div *ngFor="let name of companyNames">
      <div class="table-group">
        {{ name }}
      </div>

      <table
        mat-table
        [dataSource]="itemsByCompanyName.get(name)"
        class="billing-table"
        matSort
      >
        <ng-container matColumnDef="projectId">
          <th mat-header-cell *matHeaderCellDef class="header-text"></th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            [routerLink]="['/job', row.project.id, row.id]"
          >
            <span class="strong click-link">{{ row.project.id }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="requestDate">
          <th mat-header-cell *matHeaderCellDef class="header-text"></th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.currentCreatedAt | date : 'dd/MM/yyyy' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="executionDate">
          <th mat-header-cell *matHeaderCellDef class="header-text"></th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.currentExecutionDate | date : 'dd/MM/yyyy' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="placer">
          <th mat-header-cell *matHeaderCellDef class="header-text"></th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <employee-circle-display
              [firstName]="row.invoiceHandler?.firstName"
              [lastName]="row.invoiceHandler?.lastName"
              [profilePicture]="row.invoiceHandler?.profilePicture"
            ></employee-circle-display>
          </td>
        </ng-container>

        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef class="header-text"></th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.projectPlacement.address }}
          </td>
        </ng-container>

        <ng-container matColumnDef="productConfig">
          <th mat-header-cell *matHeaderCellDef class="header-text"></th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.project.firstProduct?.type }}
            {{ row.project.firstProduct?.measurements }} /
            {{ row.project.firstProduct?.placementDetail }}
          </td>
        </ng-container>

        <ng-container matColumnDef="displayStatus">
          <th mat-header-cell *matHeaderCellDef class="header-text"></th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <span
              [ngClass]="
                row.type
                  | overviewProjectTypeClass
                    : row.status
                    : row.withPlacement
                    : null
                    : subProjectTypeRightMargin
              "
              class="clickable status"
            >
              {{
                fixedSubProjectTypeLabel != null
                  ? fixedSubProjectTypeLabel
                  : (row.type
                    | overviewProjectType
                      : row.status
                      : row.withPlacement
                      : null)
              }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="checkedBy">
          <th mat-header-cell *matHeaderCellDef class="header-text"></th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <mat-checkbox
              disabled
              [ngModel]="
                row.billingReady != null && row.billingReady.date != null
              "
            >
              {{ row.billingReady?.byFirstName }}
              {{ row.billingReady?.byLastName }}
            </mat-checkbox>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <tr
          mat-row
          class="table-row"
          *matRowDef="let row; columns: displayedColumns"
          [ngClass]="row.bgClass"
        ></tr>
      </table>

      <div class="button-container">
        <button
          class="button"
          type="button"
          [disabled]="saving"
          (click)="createInvoice(name)"
          mat-button
        >
          Factuur aanmaken
        </button>
      </div>
    </div>
  </div>

  <!-- <div *ngIf="!items || items.length === 0" class="no-result-text">
    <div>Geen resultaten gevonden</div>
  </div> -->
  <mat-paginator
    [length]="totalItems"
    [pageSizeOptions]="pageSizeOptions"
    [showFirstLastButtons]="true"
    (page)="onPageChange()"
  ></mat-paginator>
</div>
